(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-salebar"]) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-pp-sb]').forEach((el) => {
      const cd = el.querySelector('[data-pp-cd]'); const end = Date.parse(el.dataset.ends);
      if (!cd || !end) return;
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        const left = end - Date.now();
        if (left <= 0) { cd.hidden = true; return false; }
        cd.hidden = false;
        const t = Math.floor(left / 1000);
        cd.querySelector('[data-d]').textContent = pad(Math.floor(t / 86400));
        cd.querySelector('[data-h]').textContent = pad(Math.floor(t / 3600) % 24);
        cd.querySelector('[data-m]').textContent = pad(Math.floor(t / 60) % 60);
        cd.querySelector('[data-s]').textContent = pad(t % 60);
        return true;
      };
      if (tick()) { const id = setInterval(() => { if (!tick()) clearInterval(id); }, 1000); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-store"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const fmt = (cents, f) => {
      const n = (cents / 100);
      const two = n.toFixed(2);
      return f.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
        if (k === 'amount_no_decimals') return Math.round(n).toLocaleString('en-GB');
        if (k === 'amount_with_comma_separator') return two.replace('.', ',');
        if (k === 'amount_no_decimals_with_comma_separator') return String(Math.round(n));
        return Number(two).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      });
    };
    const init = (root) => {
      if (!root || root.dataset.ready) return; root.dataset.ready = '1';
      const main = root.querySelector('[data-pps-main]');
      const thumbs = [...root.querySelectorAll('[data-pps-thumb]')];
      const show = (src) => { if (!main || !src) return; main.removeAttribute('srcset'); main.src = src; thumbs.forEach((t) => t.classList.toggle('is-on', t.dataset.ppsThumb === src)); };
      thumbs.forEach((t) => t.addEventListener('click', () => show(t.dataset.ppsThumb)));

      const dataEl = root.querySelector('[data-pps-data]');
      const form = root.querySelector('[data-pps-form]');
      if (dataEl && form) {
        const D = JSON.parse(dataEl.textContent);
        const tiers = [...form.querySelectorAll('[data-pps-tier]')];
        const atc = form.querySelector('[data-pps-atc]');
        const err = form.querySelector('[data-pps-err]');
        const find = (unit) => { const sel = [...unit.querySelectorAll('select')].map((s) => s.value); return D.variants.find((v) => v.o.every((o, i) => o === sel[i])); };
        const refresh = () => {
          tiers.forEach((t) => {
            const n = +t.dataset.ppsTier, pct = +t.dataset.pct || 0;
            const units = [...t.querySelectorAll('[data-pps-unit]')];
            let full = 0;
            let now = 0;
            // Shopify rounds each item's percentage discount down to the penny, so price each coat the same way
            units.forEach((u) => { const v = find(u) || D.variants[0]; full += v.p; now += v.p - Math.floor(v.p * pct / 100); const img = u.querySelector('[data-unit-img]'); if (v.img && img) img.src = v.img; });
            t.querySelector('[data-now]').textContent = fmt(now, D.money);
            t.querySelector('[data-was]').textContent = pct > 0 ? fmt(full, D.money) : '';
            const each = t.querySelector('[data-each]'); if (each) each.textContent = n > 1 ? fmt(Math.round(now / n), D.money) + ' each' : '';
          });
          const on = tiers.find((t) => t.classList.contains('is-on'));
          const ok = on && [...on.querySelectorAll('[data-pps-unit]')].every((u) => { const v = find(u); return v && v.a; });
          atc.disabled = !ok;
          const xid = form.querySelector('[data-pps-xid]'), xq = form.querySelector('[data-pps-xqty]');
          const xp = form.querySelector('[data-pps-express]'), mix = form.querySelector('[data-pps-mixnote]');
          if (on && xid && xq) {
            const ids = [...on.querySelectorAll('[data-pps-unit]')].map((u) => { const v = find(u); return v ? v.id : 0; });
            const same = ids.length && ids.every((id) => id && id === ids[0]);
            if (same) { xid.value = ids[0]; xq.value = ids.length; }
            if (xp) xp.hidden = !same || !ok;
            if (mix) mix.hidden = same || !xp || !xp.children.length;
          }
        };
        tiers.forEach((t) => {
          t.querySelector('input[type=radio]').addEventListener('change', () => { tiers.forEach((x) => x.classList.toggle('is-on', x === t)); refresh(); });
          t.querySelectorAll('select').forEach((s) => s.addEventListener('change', () => { const v = find(s.closest('[data-pps-unit]')); if (v && v.big) show(v.big); refresh(); }));
        });
        refresh();
        form.addEventListener('submit', async (e) => {
          e.preventDefault();
          const on = tiers.find((t) => t.classList.contains('is-on')); if (!on) return;
          const counts = {};
          on.querySelectorAll('[data-pps-unit]').forEach((u) => { const v = find(u); if (v) counts[v.id] = (counts[v.id] || 0) + 1; });
          const items = Object.entries(counts).map(([id, q]) => ({ id: +id, quantity: q }));
          form.querySelectorAll('[data-pps-addon]:checked').forEach((c) => items.push({ id: +c.dataset.ppsAddon, quantity: 1 }));
          atc.disabled = true; err.hidden = true;
          try {
            const r = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
            if (!r.ok) throw new Error((await r.json()).description || 'Could not add to cart');
            location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
          } catch (x) { err.textContent = x.message + '. Please try again.'; err.hidden = false; atc.disabled = false; }
        });
      }

      const eta = root.querySelector('[data-pps-eta]');
      if (eta) {
        const add = (d, n) => { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w && w < 6) n--; } return d; };
        const c = window.Shopify && Shopify.country;
        const f = new Intl.DateTimeFormat(c === 'US' ? 'en-US' : 'en-GB', { weekday: 'short', day: 'numeric', month: 'short' }), now = new Date();
        eta.innerHTML = 'Order today, it arrives <b>' + f.format(add(now, +eta.dataset.lo)) + ' – ' + f.format(add(now, +eta.dataset.hi)) + '</b>';
        eta.hidden = false;
      }

      const fit = root.querySelector('[data-pps-fit]');
      if (fit) {
        const max = +fit.dataset.max || 9, inp = fit.querySelector('input'), out = fit.querySelector('[data-out]'), unit = fit.querySelector('[data-unit]');
        const ranges = (fit.dataset.ranges || '').split('|').map((r) => { const m = r.split(':'); if (m.length < 2) return null; const lim = m[1].split('-').map(Number); return { size: m[0].trim(), lo: lim[0], hi: lim[1] }; }).filter(Boolean);
        fit.addEventListener('submit', () => {
          const raw = parseFloat(inp.value);
          if (!raw || raw <= 0) { out.className = 'pps-fit__out'; out.textContent = 'Enter your dog\'s weight.'; return; }
          const kg = unit && unit.value === 'lb' ? raw * 0.4536 : raw;
          if (ranges.length) {
            const hit = ranges.find((r) => kg <= r.hi + 0.001);
            if (hit) { out.className = 'pps-fit__out ok'; out.textContent = 'We recommend size ' + hit.size + '.' + (kg > hit.hi - 0.2 ? ' Close to the top of the range, so size up if your dog is chunky.' : ''); }
            else { out.className = 'pps-fit__out no'; out.textContent = 'Sorry, our largest size fits dogs up to ' + ranges[ranges.length - 1].hi + ' kg.'; }
            return;
          }
          if (kg <= max) { out.className = 'pps-fit__out ok'; out.textContent = 'Good news: your dog fits (up to ' + max + ' kg).'; }
          else { out.className = 'pps-fit__out no'; out.textContent = 'Your dog is over the ' + max + ' kg limit.'; }
        });
      }

      const rvs = [...root.querySelectorAll('[data-rv]')];
      if (rvs.length && 'IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches && !(window.Shopify && Shopify.designMode)) {
        root.classList.add('rv-on');
        const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -12% 0px' });
        rvs.forEach((el) => io.observe(el));
      }

      const rv = root.querySelector('[data-pps-revs]');
      if (rv) {
        const cards = [...rv.querySelectorAll('[data-rev]')], more = rv.querySelector('[data-more]');
        const initial = +rv.dataset.initial || 6;
        let filter = 'all', limit = initial;
        const show = () => {
          const match = cards.filter((c) => filter === 'all' || (filter === 'photo' ? c.dataset.photo === '1' : (c.dataset.d || '').includes(filter)));
          cards.forEach((c) => { c.hidden = true; });
          match.forEach((c, i) => { c.hidden = !(window.Shopify && Shopify.designMode) && i >= limit; });
          if (more) more.hidden = match.length <= limit || (window.Shopify && Shopify.designMode);
        };
        rv.querySelectorAll('[data-f]').forEach((b) => b.addEventListener('click', () => { rv.querySelectorAll('[data-f]').forEach((x) => x.classList.toggle('is-on', x === b)); filter = b.dataset.f; limit = initial; show(); }));
        if (more) more.addEventListener('click', () => { limit += initial; show(); });
        rv.querySelectorAll('[data-goto]').forEach((b) => b.addEventListener('click', () => {
          const c = cards[+b.dataset.goto]; if (!c) return;
          filter = 'all'; limit = cards.length; rv.querySelectorAll('[data-f]').forEach((x) => x.classList.toggle('is-on', x.dataset.f === 'all')); show();
          c.scrollIntoView({ behavior: 'smooth', block: 'center' }); c.classList.add('is-flash'); setTimeout(() => c.classList.remove('is-flash'), 1600);
        }));
        show();
      }

      const sticky = root.querySelector('[data-pps-sticky]');
      const atcBtn = root.querySelector('[data-pps-atc]');
      if (sticky && atcBtn) {
        // the theme scrolls inside .page-wrapper, not the window, so listen to scrolls from any element
        let raf = 0;
        const upd = () => { raf = 0; const r = atcBtn.getBoundingClientRect(); sticky.classList.toggle('is-on', r.bottom < 0); };
        const queue = () => { if (!raf) raf = requestAnimationFrame(upd); };
        document.addEventListener('scroll', queue, { capture: true, passive: true });
        window.addEventListener('resize', queue, { passive: true });
        upd();
        const sel = sticky.querySelector('[data-sticky-sel]'), add = sticky.querySelector('[data-sticky-add]'), pform = root.querySelector('[data-pps-form]');
        const syncSticky = () => { const on = root.querySelector('[data-pps-tier].is-on'); if (!on || !sel) return; const name = on.querySelector('.pps-tier__name'), now = on.querySelector('[data-now]'); sel.textContent = (name ? name.textContent.trim() : '') + (now && now.textContent ? ' · ' + now.textContent : ''); };
        if (pform) { pform.addEventListener('change', () => setTimeout(syncSticky, 0)); pform.addEventListener('click', () => setTimeout(syncSticky, 0)); }
        syncSticky();
        if (add && pform) add.addEventListener('click', () => { add.disabled = true; add.textContent = 'Adding…'; if (pform.requestSubmit) pform.requestSubmit(); else pform.dispatchEvent(new Event('submit', { cancelable: true })); setTimeout(() => { add.disabled = false; add.textContent = add.dataset.label || 'Add to cart'; }, 4000); });
      }
    };
    document.querySelectorAll('.pps').forEach(init);
    document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('.pps')));
    // theme editor: clicking a block in the sidebar brings it into view, including cards in sideways-scrolling rows
    document.addEventListener('shopify:block:select', (e) => { if (e.target.closest('.pps')) e.target.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' }); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pup-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.ppReady) return; root.dataset.ppReady = '1';
      const main = root.querySelector('[data-pp-main]');
      const thumbs = [...root.querySelectorAll('[data-pp-thumb]')];
      const show = (src) => { if (!main || !src) return; main.removeAttribute('srcset'); main.src = src; thumbs.forEach((t) => t.classList.toggle('is-on', t.dataset.ppThumb === src)); };
      thumbs.forEach((t) => t.addEventListener('click', () => show(t.dataset.ppThumb)));

      const data = root.querySelector('[data-pp-variants]');
      const form = root.querySelector('[data-pp-form]');
      if (data && form) {
        const variants = JSON.parse(data.textContent);
        const idIn = form.querySelector('[data-pp-id]');
        const atc = form.querySelector('[data-pp-atc]');
        const price = root.querySelector('[data-pp-price]');
        const label = atc.textContent;
        const radios = [...form.querySelectorAll('[data-pp-opt]')];
        const pick = () => {
          const sel = [];
          radios.forEach((r) => { if (r.checked) sel[+r.dataset.ppOpt] = r.value; });
          const v = variants.find((x) => x.o.every((o, i) => o === sel[i]));
          if (!v) { atc.disabled = true; atc.textContent = 'Unavailable'; return; }
          idIn.value = v.id;
          atc.disabled = !v.a; atc.textContent = v.a ? label : 'Sold out';
          price.innerHTML = '<span class="pp-price__now">' + v.p + '</span>' + (v.c ? '<s class="pp-price__was">' + v.c + '</s>' : '');
          if (v.m) show(v.m);
        };
        radios.forEach((r) => r.addEventListener('change', pick));
      }

      const sticky = root.querySelector('[data-pp-sticky]');
      const buy = root.querySelector('.pp-buy');
      const hero = root.querySelector('.pp-hero');
      if (sticky && buy && hero && 'IntersectionObserver' in window) {
        let pastHero = false, inBuy = false;
        const sync = () => sticky.classList.toggle('is-on', pastHero && !inBuy);
        new IntersectionObserver(([e]) => { pastHero = !e.isIntersecting && e.boundingClientRect.top < 0; sync(); }).observe(hero);
        new IntersectionObserver(([e]) => { inBuy = e.isIntersecting; sync(); }, { threshold: 0.15 }).observe(buy);
      }
    };
    document.querySelectorAll('.pp').forEach(init);
    document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('.pp')));
  })();

  } catch(e) { console.error(e); }
})();
})();
